import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';

export interface SelectPillItem {
  value: string;
  label: string;
}

@Component({
  selector: 'l-select-pill',
  standalone: true,
  templateUrl:     './select-pill.component.html',
  imports: [CommonModule, TooltipModule],
})
export class SelectPillComponent {
  @Input()
  public items: SelectPillItem[] = [];

  @Input()
  public maxVisiblePills: number = 5;

  @Input()
  public overflowPrefix: string = 'e mais';

  @Input() 
  public label: string = '';

  @Input() 
  public removable: boolean = false;

  @Output()
  public remove = new EventEmitter<string>();

  public get visibleItems(): SelectPillItem[] {
    return this.items.slice(0, this.safeMaxVisiblePills);
  }

  public get hiddenItemsCount(): number {
    return Math.max(0, this.items.length - this.safeMaxVisiblePills);
  }

  public get hiddenItemsTooltip(): string {
    return this.items.slice(this.safeMaxVisiblePills).map((item) => item.label).join('\n');
  }

  public onRemove(event: Event, value: string): void {
    event.stopPropagation();
    this.remove.emit(value);
  }

  public trackByValue(index: number, item: SelectPillItem): string {
    return `${item.value}-${index}`;
  }

  private get safeMaxVisiblePills(): number {
    return Math.max(1, this.maxVisiblePills);
  }
}
